import { ChatConversation, ChatConversationCategory, ChatSnapshot } from "../types";

const CATEGORY_ORDER: ChatConversationCategory[] = ["unread", "inbox", "communities"];

function sortConversations(conversations: ChatConversation[]): ChatConversation[] {
  return [...conversations].sort((a, b) => {
    const timeA = a.time ? Date.parse(a.time) : 0;
    const timeB = b.time ? Date.parse(b.time) : 0;
    return timeB - timeA;
  });
}

export function mergeConversation(snapshot: ChatSnapshot, conversation: ChatConversation): ChatSnapshot {
  const roster = { ...snapshot.roster, [conversation.id]: conversation };

  const conversationsByCategory: Record<ChatConversationCategory, ChatConversation[]> = {
    inbox: [...snapshot.conversations.inbox],
    unread: [...snapshot.conversations.unread],
    communities: [...snapshot.conversations.communities],
  };

  const category: ChatConversationCategory = conversation.group ? "communities" : conversation.unreadCount > 0 ? "unread" : "inbox";

  for (const key of CATEGORY_ORDER) {
    const list = conversationsByCategory[key];
    const existingIndex = list.findIndex((item) => item.id === conversation.id);
    if (existingIndex >= 0) {
      list.splice(existingIndex, 1);
    }
  }

  conversationsByCategory[category] = sortConversations([
    conversation,
    ...conversationsByCategory[category],
  ]);

  return {
    roster,
    conversations: conversationsByCategory,
  };
}

export function mergeRoster(snapshot: ChatSnapshot, conversations: ChatConversation[]): ChatSnapshot {
  let next = snapshot;
  for (const conversation of conversations) {
    next = mergeConversation(next, conversation);
  }
  return next;
}

